import React, { useEffect } from "react";

export default function AdTinybanner({}) {
  useEffect(() => {
    /*global blogherads */
    blogherads.adq.push(["tinybanner", "skm-ad-tinybanner"]);
  });

  return <div id="skm-ad-tinybanner"></div>;
}
